import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiStar, FiUser } = FiIcons;

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah J.',
      role: 'Content Creator',
      rating: 5,
      text: 'Premium SMM Panel helped me grow my Instagram from 500 to 50K followers in just 3 months. The quality is amazing and the support team is incredibly helpful!',
      bgColor: 'bg-pink-500'
    },
    {
      name: 'Mike C.',
      role: 'Digital Marketer',
      rating: 5,
      text: 'As a digital marketing agency, we need reliable SMM services. Premium SMM Panel delivers consistent quality and fast results for all our clients.',
      bgColor: 'bg-blue-500'
    },
    {
      name: 'Emma R.',
      role: 'Business Owner',
      rating: 5,
      text: 'The best investment for my business! My YouTube channel views increased by 300% and my engagement rates are through the roof. Highly recommended!',
      bgColor: 'bg-green-500'
    },
    {
      name: 'David L.',
      role: 'Influencer',
      rating: 5,
      text: 'Outstanding service! Got 10K TikTok followers in 24 hours. The delivery was smooth and all followers look completely natural. Will definitely order again!',
      bgColor: 'bg-purple-500'
    },
    {
      name: 'Lisa M.',
      role: 'Social Media Manager',
      rating: 5,
      text: 'I manage multiple client accounts and Premium SMM Panel is my go-to service. Fast delivery, great prices, and excellent customer support every time.',
      bgColor: 'bg-orange-500'
    },
    {
      name: 'Alex K.',
      role: 'YouTuber',
      rating: 5,
      text: 'Amazing results! My video got 100K views overnight and the engagement is fantastic. The quality is top-notch and delivery was exactly as promised.',
      bgColor: 'bg-indigo-500'
    },
    {
      name: 'Maria S.',
      role: 'Fashion Blogger',
      rating: 5,
      text: 'Premium SMM Panel transformed my Instagram presence. The followers are high-quality and my engagement rates have never been better. Absolutely worth it!',
      bgColor: 'bg-teal-500'
    },
    {
      name: 'James W.',
      role: 'Entrepreneur',
      rating: 5,
      text: 'Tried many SMM panels but this one is by far the best. Fast delivery, real-looking followers, and competitive prices. Customer service is also excellent!',
      bgColor: 'bg-red-500'
    },
    {
      name: 'Sophie T.',
      role: 'Music Artist',
      rating: 5,
      text: 'My music career took off after using their services. Got thousands of real followers and my songs are getting more plays than ever. Highly recommend!',
      bgColor: 'bg-yellow-500'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't just take our word for it. Here's what our satisfied customers have to say about their experience with Premium SMM Panel.
          </p>
        </motion.div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-gray-50 rounded-2xl p-8 border border-gray-200 hover:shadow-xl transition-all duration-300"
            >
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon
                    key={i}
                    icon={FiStar}
                    className="w-5 h-5 text-yellow-400 fill-current"
                  />
                ))}
              </div>
              
              <div className="mb-6">
                <p className="text-gray-700 leading-relaxed">{testimonial.text}</p>
              </div>
              
              <div className="flex items-center space-x-4">
                <div className={`w-12 h-12 ${testimonial.bgColor} rounded-full flex items-center justify-center`}>
                  <SafeIcon icon={FiUser} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">{testimonial.name}</h4>
                  <p className="text-gray-600 text-sm">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;